import { SUPPORT_REQUESTED_SUCCESS, SUPPORT_REQUESTED_FAILURE } from '@/redux/actions/support.actions'

const suppportRequestSuccess = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'Support Request',
		eventAct: action.payload,
		eventLbl: ''
	}
}

const suppportRequestError = (action) => {
	return {
		event: 'eventoGA',
		eventCat: 'Support Request error',
		eventAct: action.payload.message,
		eventLbl: ''
	}
}

export default {
	[SUPPORT_REQUESTED_SUCCESS]: suppportRequestSuccess,
	[SUPPORT_REQUESTED_FAILURE]: suppportRequestError
}
